<!--
 * @Author:
 * @LastEditTime: 2023-01-17 15:34:52
 * @Description:
-->
<template>
  <div id="app" class="w-full h-full" v-loading="!showPage">
    <router-view v-if="showPage" />
  </div>
</template>

<script type="text/babel">
import FnMixins from '@/assets/js/fnMixins'

export default {
  name: 'app',
  components: {},
  mixins: [FnMixins],
  data() {
    return {
      showPage: true,
    }
  },
  mounted() {
    const themeConfig = Wiz.globalSettings.layout.config
    // 存在灰色主题配置
    if (themeConfig && themeConfig.isGray) {
      document.documentElement.classList.add('grayscale')
    }
  },
}
</script>

<style lang="scss" scoped></style>
